import React from 'react';
import {CONFIG_TABLE_MAX_X, PERMISSION_INVITES, SECURITY_ROLE_OWNER} from "../../constants/constants";
import {deleteUser, exportUsers, getUsers} from "../../services/UsersService";
import {getAllActions} from "../../services/ActionsService";
import {getClientById} from "../../services/ClientsService";
import {getAllGroups} from "../../services/GroupsService";
import DialogTextInputFilter from "../../components/DialogTextInputFilter";
import EntriesIterator from "../../components/EntriesIterator";
import {Button, Descriptions, Divider, Icon, Popconfirm, Table, Tag} from 'antd';
import UsersManage from "./UsersManage";

class Users extends EntriesIterator {

    processPaginatedRequest(page, rows, filters) {
        if (this.props.client) {
            this.loadRequiredInformation();
            return getUsers(page, rows, filters, this.props.client);
        }
        return new Promise(function (resolve, reject) {
            resolve({content: [], totalElements: 0});
        });
    }

    reloadPage = (user) => {
        this.onPage(this.state.page, this.state.filters);
        this.setState({userFormKey: "formUserAdmin" + new Date().getTime()});
    };

    exportUsers = (filters, client) => {
        exportUsers(filters, client);
    };

    openEditUser = (user, checked) => {
        this.setState({
            currentEditUser: user,
            showManageUser: true,
            userChecked: checked
        });
    };

    closeEditUser = () => {
        if (this.state.showManageUser) {
            this.setState({showManageUser: false});
        }
    };

    deleteUser = (user) => {
        this.setState({isLoading: true});
        deleteUser(user.id, this.props.client).then(() => {
            this.reloadPage();
        });
    };

    editButtons = (user) => {
        const key = user.id;
        const userDeleteLink = this.props.currentUser && this.props.currentUser.id !== user.id ?
            <Popconfirm title="¿Eliminar este usuario?" onConfirm={() => {
                this.deleteUser(user)
            }} cancelText="Cancelar">
                <a href="#2"><Icon type="delete" theme="twoTone"/></a>
            </Popconfirm> :
            <Icon type="delete" theme="outlined"/>;
        return <div className="edit-user-actions">
                <span onClick={(e) => this.openEditUser(user, true)} key={"edit" + key}>
                    <a href="#edit">
                        <Icon type="edit" theme="twoTone"/>
                    </a>
            </span>
            <Divider type="vertical"/>
            {userDeleteLink}
        </div>
    };

    userRole(user) {
        let color = 'geekblue';
        let label = 'USUARIO';
        if (user && user.hasOwnProperty('clients')) {
            const role = user.clients[this.props.client] ? user.clients[this.props.client].role : '';
            label = role === SECURITY_ROLE_OWNER ? 'ADMINISTRADOR' : 'USUARIO';
            color = role === SECURITY_ROLE_OWNER ? 'green' : 'geekblue';
        }
        return (
            <Tag color={color}>
                {label}
            </Tag>
        );
    }

    userAccessInvite(user) {
        if (user && user.hasOwnProperty('clients')) {
            const role = user.clients[this.props.client] ? user.clients[this.props.client].role : '';
            if (role === SECURITY_ROLE_OWNER) {
                return true;
            }
            const permissions = user.clients[this.props.client] ? user.clients[this.props.client].permissions : [];
            return permissions.includes(PERMISSION_INVITES);
        }
        return false;
    }

    userActions(user) {
        if (user && user.hasOwnProperty('clients')) {
            const role = user.clients[this.props.client] ? user.clients[this.props.client].role : '';
            if (role === SECURITY_ROLE_OWNER && this.state.actions) {
                return Object.values(this.state.actions).map(action => action.name).map(n => <Tag>{n}</Tag>);
            }
            return user.clients[this.props.client] && this.state.actions ?
                user.clients[this.props.client].actions
                    .map(actionId => this.state.actions[actionId]
                        ? this.state.actions[actionId].name : actionId).map(n => <Tag>{n}</Tag>) : '-';
        }
        return '';
    }

    userGroups(user) {
        if (user && user.hasOwnProperty('clients')) {
            const client = user.clients[this.props.client];
            return client && this.state.groups ?
                client.groups.filter(groupId => this.state.groups[groupId])
                    .map(groupId => this.state.groups[groupId].name).map(n => <Tag>{n}</Tag>) : '-';
        }
        return '';
    }

    loadRequiredInformation() {
        const _this = this;
        getAllGroups(undefined, this.props.client).then((groups) => {
            let groupsMap = {};
            if (groups && groups.content) {
                groups.content.forEach(group => {
                    groupsMap[group.id] = group;
                });
            }
            _this.setState({groups: groupsMap});
        });
        getAllActions(this.props.client).then((actions) => {
            let actionsMap = {};
            if (actions && actions.content) {
                actions.content.forEach(action => {
                    actionsMap[action.id] = action;
                });
            }
            _this.setState({actions: actionsMap});
        });
        getClientById(this.props.client).then((client) => {
            _this.setState({client: client});
        });
    }

    handleChange(value, key) {
        this.setState({
            [key]: value
        }, () => {
            this.resetAll(this.onPage(0));
        });
    }

    renderView() {
        let hasEditPermissions = this.props.isAdmin || this.props.isOwner;

        let columns = [{
            title: 'Correo electrónico',
            dataIndex: 'email',
            key: 'email',
            filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters}) => (
                <DialogTextInputFilter
                    placeholder='Correo electrónico'
                    selectedKeys={selectedKeys}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onSearch={this.handleFilterSearch(selectedKeys, confirm)}
                    onReset={this.handleFilterReset(clearFilters)}/>
            ),
        }, {
            title: 'Nombre',
            dataIndex: 'name',
            key: 'name',
            filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters}) => (
                <DialogTextInputFilter
                    placeholder='Nombre'
                    selectedKeys={selectedKeys}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onSearch={this.handleFilterSearch(selectedKeys, confirm)}
                    onReset={this.handleFilterReset(clearFilters)}/>
            ),
        }, {
            title: 'Dirección',
            key: 'address',
            render: user => {
                return user.clients[this.props.client] ? user.clients[this.props.client].address : '';
            }
        }, {
            title: 'Rol',
            key: 'roles',
            render: user => {
                return this.userRole(user);
            }
        }];
        if (hasEditPermissions) {
            columns.push({
                key: 'operations',
                render: (user) => <div>{
                    this.editButtons(user)
                }</div>,
                width: '5em',
                align: 'center'
            })
        }
        const actionButtons = hasEditPermissions ?
            <div className="action-separator">
                <Button key="userAddBtn"
                        type="primary"
                        className="mrg-right"
                        onClick={() => {
                            this.openEditUser({}, false)
                        }}>
                    <Icon type="plus"/>
                    Adicionar
                </Button>
                <Button key="exportAddBtn"
                        type="default"
                        className="mrg-right"
                        onClick={() => {
                            this.exportUsers(this.state.filters, this.props.client)
                        }}>
                    <Icon type="cloud-download" />
                    Exportar resultados
                </Button>
            </div> :
            null;

        return <div>
            {actionButtons}
            <UsersManage
                user={this.state.currentEditUser ? this.state.currentEditUser : {}}
                groups={this.state.groups}
                client={this.state.client}
                actions={this.state.actions} currentClient={this.props.client}
                currentUser={this.props.currentUser}
                key={this.state.userFormKey ? this.state.userFormKey : 'formUserAdmin'} isAdmin={this.state.isAdmin}
                showEdit={this.state.showManageUser}
                userChecked={this.state.userChecked}
                onSave={this.reloadPage} onDelete={this.reloadPage} onClose={this.closeEditUser}/>

            <Table dataSource={this.state.data} columns={columns} loading={this.state.loading}
                   scroll={{x: CONFIG_TABLE_MAX_X}}
                   pagination={this.getPagination()} size="small" onChange={this.handleStateChange} rowKey="id"
                   expandedRowRender={user =>
                       <div>
                           <Descriptions>
                               <Descriptions.Item label="Identificación">{user.identification}</Descriptions.Item>
                               <Descriptions.Item label="¿Puede crear invitaciones?"><Icon
                                   type={this.userAccessInvite(user) ? 'check-circle' : 'close-circle'}/></Descriptions.Item>
                               <Descriptions.Item label="Acceso a">{this.userActions(user)}
                               </Descriptions.Item>
                               <Descriptions.Item label="Grupos">{this.userGroups(user)}</Descriptions.Item>
                           </Descriptions>
                       </div>
                   }/>
        </div>
    }
}

export default Users;


// WEBPACK FOOTER //
// ./src/app/views/users/Users.js